import { api } from '@/services'

const state = {
  rechargeFields: {
    comment: null,
    value: null,
    type: null,
    credit_card: {
      info: {
        holder_name: null,
        number: null,
        expiry_month: null,
        expiry_year: null,
        ccv: null,
      },
      holder: {
        name: null,
        email: null,
        cpf_cnpj: null,
        postal_code: null,
        phone: null,
        address_number: null,
      },
    },
  },

  successData: null,
  pixData: {},
}

const getters = {
  rechargeFields: (state) => state.rechargeFields,
  billetSuccess: (state) => state.billetSuccess,
  successData: (state) => state.successData,
  pixData: (state) => state.pixData,
}

const actions = {
  async handleRecharge({ commit, dispatch }) {
    commit('setIsLoading', true)

    try {
      const response = await api.post(
        'web/recharge/request',
        state.rechargeFields
      )

      dispatch('fetchRecharges')
      commit('setSuccessData', response.data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async refreshPixRecharge({ commit, dispatch }, pixId) {
    commit('setIsLoading', true)

    try {
      const { data } = await api.get(`web/recharge/refresh/${pixId}`)
      commit('setPixData', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },
}

const mutations = {
  setRechargeFields: ({ rechargeFields }, fields) => {
    state.rechargeFields = { ...rechargeFields, ...fields }
  },

  setPixData: (state, data) => {
    state.pixData = data
  },

  setSuccessData: (state, data) => {
    state.successData = data
  },

  resetRechargeFields: () => {
    state.rechargeFields = {
      comment: null,
      value: null,
      type: null,
      credit_card: {
        info: {
          holder_name: null,
          number: null,
          expiry_month: null,
          expiry_year: null,
          ccv: null,
        },
        holder: {
          name: null,
          email: null,
          cpf_cnpj: null,
          postal_code: null,
          phone: null,
          address_number: null,
        },
      }
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
